module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-margin-bottom"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("集体学习")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid content-style"
  }, [_c('div', {
    staticClass: "jieshao_ul"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/44.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2026年4月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("腾讯Work Buddy智能体应用分享")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/43.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2026年3月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("OPEN CLAW学习与应用")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/42.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年12月27日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI工具挑战赛2.0")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/41.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年11月30日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI应用实战培训")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/40.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年10月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI工具挑战赛")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/39.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年9月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("AI应用学习分享")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/38.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年9月1日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("南站喜街乐跑赛")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/37.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年7月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("亚运城喜街参观考察"), _c('br'), _vm._v("《关于企业与个人成长的思考》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/36.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年5月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("1906科技园扬韬广场参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/35.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年4月27日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("三七互娱全球总部参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/34.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年3月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("东谷中心商业参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/33.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2025年2月5日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("2025开年登山活动")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/32.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年11月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《价值主张Ⅱ》内部研讨会")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/31.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年10月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《价值主张》内部研讨会")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/30.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年9月21日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("2024南站喜街乐跑赛")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/29.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年8月24日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("深化军队文化建设"), _c('br'), _vm._v("《我们的时代，我们的奋斗》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/28.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年7月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("中国经济形势分析")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/27.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年6月29日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《TED》演讲视频合集学习与讨论")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/26.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年5月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("保利鱼珠时光商业参观考察"), _c('br'), _vm._v("美林M·LIVE天地商业参观考察")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/25.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年4月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("思维导图与PPT应用大比武")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/24.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年3月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("PPT与思维导图深化运用")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/23.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2024年2月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("黄埔军校旧址参观学习")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/22.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年12月16日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("业务本领学习与复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/21.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年11月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("业务本领学习与复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/20.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年10月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("业务本领学习与复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/19.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年9月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("熙二戈壁110公里感悟分享")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/18.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年8月16日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("香港商业街区走访学习")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/17.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年7月29日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("亚运城喜街项目历程分享及实地走访")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/16.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年7月1日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《营销平台研究与探索》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/01.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年5月27日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("ChatGPT实操")]), _vm._v(" "), _c('p', [_vm._v("《对标企业商业模式研究》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/02.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年4月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《所有人都能玩转的ChatGPT》")]), _vm._v(" "), _c('p', [_vm._v("《我国发展商业地产REITS模式研究》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/03.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年3月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《人工智能》")]), _vm._v(" "), _c('p', [_vm._v("《房地产投资信托基金》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/04.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2023年2月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("同熙商业3.0模式复盘")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/05.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年12月31日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("大夫山户外拓展学习会")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/06.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年11月26日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《海外市场商业地产现状及动向》")]), _vm._v(" "), _c('p', [_vm._v("《数字化建设案例或实践学习》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/07.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年10月29日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《深化军队文化建设》系列")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/08.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年9月18日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("“熙一”十人分享感悟")]), _vm._v(" "), _c('p', [_vm._v("《一人一厨一狗》华为系列故事学习")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/09.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年8月28日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《向军队学习执行力》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/10.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年7月23日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《苏世民：我的经验与教训》")]), _vm._v(" "), _c('p', [_vm._v("《商业运营学习分享》")]), _vm._v(" "), _c('p', [_vm._v("《公司法》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/11.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年6月25日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《商业地产的投资要点与难点》")]), _vm._v(" "), _c('p', [_vm._v("《商业地产的营销要点与难点》")]), _vm._v(" "), _c('p', [_vm._v("《商业地产的商管运营要点与难点》")]), _vm._v(" "), _c('p', [_vm._v("《我在世界五百强的工作经验》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/12.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年5月21日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《建立学习型团队》")]), _vm._v(" "), _c('p', [_vm._v("《活到老学到老》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/13.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年4月16日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《访问美军院校见闻》")]), _vm._v(" "), _c('p', [_vm._v("《康熙五十六年谕旨》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/14.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年3月19日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《黄奇帆独家解读房地产》")]), _vm._v(" "), _c('p', [_vm._v("《灰度法则打造华为常胜铁军》")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "imgs/culture_xx/15.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习时间")]), _vm._v(" "), _c('p', [_vm._v("2022年2月19日")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h3', [_vm._v("学习内容")]), _vm._v(" "), _c('p', [_vm._v("《华为如何锻造打胜仗的组织》")]), _vm._v(" "), _c('p', [_vm._v("《华为向军队学习了什么》")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0",
      "margin": "0"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0",
      "margin": "0"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0",
      "margin": "0"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61629cc3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/culture_xx.vue
// module id = 110
// module chunks = 2